import { createApi } from '@reduxjs/toolkit/dist/query/react';

import type { OnboardingPath } from '@app/features/quick-start/data';

import fetchBaseQuery from '../fetchBaseQuery';

export type ProjectSetupBase = {
    projectName: string | null;
    keyName: string | null;
    keyBaseValue: string | null;
    platforms: (1 | 2 | 4 | 16)[] | null;
    companyRole: number | null;
    contentLocation: number | null;
    totalStepsCount: number | null;
};

export type ProjectSetupResponseValues = {
    sourceLanguage: {
        value: number;
        label: string;
    } | null;
    targetLanguages: {
        value: number;
        label: string;
    }[];
};

export type ProjectSetup = ProjectSetupBase & ProjectSetupResponseValues;

type ProjectSetupPayload = ProjectSetupBase & {
    sourceLanguageId: number;
    targetLanguageIds: number[];
};

// All parameters are actually optional, as the `PUT /project-setup` endpoint has 2 different responses
export type ProjectSetupResponse = {
    onboardingPath: OnboardingPath;
    projectId: string;
    // Where is this is supposed to be coming from? I don't see it on the back-end.
    result: string;
};

export const projectSetupApi = createApi({
    reducerPath: 'projectSetup',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['projectSetup'],
    endpoints: (builder) => ({
        getProjectSetupData: builder.query<ProjectSetup, void>({
            query: () => ({
                method: 'GET',
                url: `/project-setup/`,
            }),
            providesTags: ['projectSetup'],
        }),
        setProjectSetupData: builder.mutation<ProjectSetupResponse, Partial<ProjectSetupPayload>>({
            query: (payload) => ({
                url: '/project-setup/',
                method: 'PUT',
                body: payload,
            }),
        }),
    }),
});

export const { useGetProjectSetupDataQuery, useSetProjectSetupDataMutation } = projectSetupApi;

export default projectSetupApi;
